function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import $ from 'jquery';
import WDHCarouselStack from './wdh-carousel-stack';
import { onLoad, onResize, onEvent, onScroll, WDHComponent } from '../../../../wdh-foundation/wdh';
var _window = window,
  DGS = _window.DGS;

/**
 * Carousel - The carousel component will wrap contiguous components with the same class name (default: carousel-slide) together to create a carousel of components.
 * @author JTTO
 * @memberOf WDHCarousel
 */
var WDHCarousel = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @constructor
   * @param {string} [className=carousel-slide] className - the class name for the components which should be grouped together as a single carousel.
   */
  function WDHCarousel() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'carousel-slide';
    _classCallCheck(this, WDHCarousel);
    _this = _callSuper(this, WDHCarousel, [className]);

    /**
     * @private
     * @type {boolean}
     */
    _this.inEditMode = document.body ? document.body.classList.contains('mode-editing') : false;
    /**
     * options for the Carousel
     * @type {Object} options
     * @type {boolean} [false] options.slideOnMobile - whether the component should be displayed as a carousel object on mobile.
     * @type {number} [5000] options.slideInterval - the length of time in milliseconds that the current slide of the carousel should display for before switching.
     * @type {boolean} [false] options.sliderTabsBelow - whether to place the dot navigation bar below the entire carousel
     */
    _this.options = {
      slideOnMobile: false,
      hasRestrictedSlides: false,
      restrictedSlideClass: '',
      slideInterval: 5000,
      sliderTabsBelow: false
    };
    /**
     * @private
     * @type {string}
     */
    _this.slideOnMobileClass = 'banner-carousel-slide-on-mobile';
    /**
     * @private
     * @type {string}
     */
    _this.slideNavigationBelowClass = 'banner-carousel-tabs-below';
    _this.stacks = [];
    return _this;
  }

  /**
   * function to set our default options for the carousel
   * @param options {object}
   */
  _inherits(WDHCarousel, _WDHComponent);
  return _createClass(WDHCarousel, [{
    key: "setOptions",
    value: function setOptions(options) {
      if (_typeof(options) === 'object') {
        var tempOptions = Object.assign({}, this.options, options);
        this.options = tempOptions;
      }
    }

    /**
     * loops through all components on the page and builds a carousel out of all components with the className defined in the constructor.
     * overrides WDHComponent run() method.
     */
  }, {
    key: "run",
    value: function run() {
      var _this2 = this;
      onLoad(function () {
        _this2.initSlideshow();
      });
    }
  }, {
    key: "initSlideshow",
    value: function initSlideshow() {
      var _this3 = this;
      var group = null;

      // set groupOptions to our defaults
      var groupOptions = Object.assign({}, this.options);

      // loop through all components on the screen to determine if they are a slider-stack.
      $('.component').each(function (index, element) {
        var $this = $(element);
        if ($this.hasClass(_this3.className)) {
          // check if designer added the banner-carousel-slide-on-mobile class to any element in our stack. If so, apply it to the entire stack
          if (!groupOptions.slideOnMobile) {
            groupOptions = Object.assign(groupOptions, {
              slideOnMobile: $this.hasClass(_this3.slideOnMobileClass)
            });
          }

          // check if we want the navigation dots to be below the slides
          if (!groupOptions.sliderTabsBelow) {
            groupOptions = Object.assign(groupOptions, {
              sliderTabsBelow: $this.hasClass(_this3.slideNavigationBelowClass)
            });
          }
          if (!group) {
            group = $this;
          } else {
            group = $.merge(group, $this);
          }
        } else {
          if (group) {
            _this3.setupGroup(group, groupOptions);
            // reset our group options so that additional carousels can work independently.
            groupOptions = Object.assign({}, _this3.options);
          }
          group = null;
        }
      });
      if (group) {
        this.setupGroup(group, groupOptions);
        // reset our group options so that additional carousels can work independently.
        groupOptions = Object.assign({}, this.options);
      }
    }

    /**
     * initializes all components on the page that were grouped together as a single Carousel object.
     * @param {jQuery} group - group of DOM elements that have the default carousel className.
     * @param groupOptions - custom options for the carousel object
     */
  }, {
    key: "setupGroup",
    value: function setupGroup(group, groupOptions) {
      if (this.inEditMode) {
        group.each(function (index, element) {
          $(element).addClass('slide-index');
          $(element).attr('data-index', "slide : ".concat(index + 1));
        });
      }

      // Build each carousel component.
      var stack = new WDHCarouselStack(group);
      this.stacks.push(stack);
      groupOptions = Object.assign({
        editMode: this.inEditMode
      }, groupOptions);
      stack.setOptions(groupOptions);
      stack.init();
      this.components.push(stack.getInstance()); // returns the node for the carousel wrapper.

      onResize(function () {
        onEvent(DGS.Events.RESIZE_DONE, function () {
          stack.resize();
        });
      });
      onScroll(function (scrollTop) {
        stack.onScroll(scrollTop);
      });
    }

    /**
     * resets stack with new options.
     * @param options {Object} options object
     * @param target {string} optional classname to target individual stacks
     */
  }, {
    key: "resetStack",
    value: function resetStack(options) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var targets = this.stacks;
      if (target !== '') {
        targets = this.stacks.filter(function (stack) {
          return $(stack.slides).hasClass(target);
        });
      }
      targets.forEach(function (stack) {
        stack.setOptions(options);
        stack.run(true);
      });
    }
  }]);
}(WDHComponent);
export default WDHCarousel;